import { InputAdornment, TextField } from '@mui/material';
import { validDecimal } from 'app/helpers/numberHelper';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const TotalAmount = () => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const totalAmount = 'totalAmount';
  const isModEdit = useSelector(selectIsEditMod);

  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);

  const validation = () => {
    if (getValues(totalAmount)) {
      clearErrors(totalAmount);
    } else {
      setError(totalAmount, {});
    }
  };

  useEffect(() => {
    validation();
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={totalAmount}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.totalAmount')}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          value={getValues(totalAmount) ?? ''}
          required={true}
          onChange={e => {
            if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(totalAmount, validInput, { shouldDirty: true });
              validation();
            }
          }}
        />
      )}
    />
  );
};
